export const GET_BONUS = "GET_BONUS";
export const GET_STATE_LOADING = "GET_STATE_LOADING";
